module.exports = __webpack_public_path__ + "static/media/mtb-pay-2.5954e3ad.jpg";